export default __webpack_public_path__ + "static/media/FabricUpholsteryFeltMilled001_BUMP_3K.7736ff1d.jpg";